// Tiny typed event emitter. Real handlers announce what happened (`nav:self`,
// `orb:open`, ...); the OnboardingProvider listens and advances the tour.
export type TourListener = (event: string) => void;

const listeners = new Set<TourListener>();

export const tourBus = {
  emit(event: string): void {
    // Copy so a listener may unsubscribe while we iterate.
    for (const fn of Array.from(listeners)) {
      try {
        fn(event);
      } catch {
        /* a bad listener must never break the app handler that emitted */
      }
    }
  },
  on(fn: TourListener): () => void {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  },
};
